export const IconInstagram = ({ size = 17 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);

export const IconFacebook = ({ size = 17 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

export const IconTwitter = ({ size = 17 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const IconTikTok = ({ size = 17 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.79 1.52V6.73a4.84 4.84 0 01-1.02-.04z" />
  </svg>
);

export const IconUser = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
  </svg>
);

export const IconCart = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <path d="M16 10a4 4 0 01-8 0" />
  </svg>
);

// HOW IT WORKS icons
export const IconForm = () => (
  <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" width="72" height="72">
    <rect x="18" y="12" width="50" height="66" rx="5" stroke="#111" strokeWidth="3.5" />
    <line x1="30" y1="32" x2="56" y2="32" stroke="#111" strokeWidth="3" />
    <line x1="30" y1="44" x2="56" y2="44" stroke="#111" strokeWidth="3" />
    <line x1="30" y1="56" x2="46" y2="56" stroke="#111" strokeWidth="3" />
    <circle cx="64" cy="66" r="14" stroke="#111" strokeWidth="3.5" />
    <path d="M58 66l4.5 4.5 8-8" stroke="#e8272a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconDesign = () => (
  <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" width="72" height="72">
    <rect x="14" y="26" width="48" height="34" rx="4" stroke="#111" strokeWidth="3.5" />
    <line x1="38" y1="60" x2="38" y2="72" stroke="#111" strokeWidth="3" />
    <line x1="26" y1="72" x2="50" y2="72" stroke="#111" strokeWidth="3" />
    <circle cx="76" cy="34" r="12" stroke="#111" strokeWidth="3.5" />
    <path d="M69 31c0-3.9 3.1-7 7-7s7 3.1 7 7-3.1 7-7 7" stroke="#111" strokeWidth="2.5" />
    <path d="M76 38v3" stroke="#e8272a" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

export const IconReveal = () => (
  <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" width="72" height="72">
    <circle cx="50" cy="38" r="11" stroke="#111" strokeWidth="3.5" />
    <circle cx="26" cy="52" r="9" stroke="#111" strokeWidth="3.5" />
    <circle cx="74" cy="52" r="9" stroke="#111" strokeWidth="3.5" />
    <path d="M50 49v16M40 68h20" stroke="#111" strokeWidth="3" strokeLinecap="round" />
    <path d="M18 43l-7-9M82 43l7-9" stroke="#e8272a" strokeWidth="3" strokeLinecap="round" />
    <path d="M12 32l6 2-2 6" stroke="#e8272a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M88 32l-6 2 2 6" stroke="#e8272a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
